import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  Player,
  ControlBar,
  ForwardControl,
  BigPlayButton,
  ReplayControl,
  LoadingSpinner,
} from "video-react";

import { useReduxStore } from "../../hooks/useReduxStore";
import useAdGate from "../../hooks/useAdGate";
import AdVideoModal from "../../Components/AdVideoModal";

const VedioPlayer = (props) => {
  const location = useLocation();
  const { getState } = useReduxStore();
  const { itemDetail } = getState("Item");
  const { image: posterImage, file: vedioUrl } = itemDetail || {};

  const {
    isAdModalOpen,
    adData,
    triggerWithAdGate,
    onAdCompleted,
    closeAdModal,
    isSubscribed,
  } = useAdGate();

  const isFree = Number(itemDetail?.price) === 0;
  const alreadyWatched = Boolean(location?.state?.adCompleted);
  const [adFinished, setAdFinished] = useState(
    !isFree || isSubscribed || alreadyWatched
  );

  useEffect(() => {
    if (isFree && !isSubscribed && !alreadyWatched) {
      triggerWithAdGate(itemDetail, () => {
        setAdFinished(true);
      });
    }
  }, [isFree, isSubscribed, alreadyWatched, itemDetail, triggerWithAdGate]);

  const handleAdDone = () => {
    onAdCompleted();
    setAdFinished(true);
  };

  return (
    <div className="h-screen overflow-hidden w-screen bg-black">
      {adFinished && vedioUrl && (
        <Player
          autoPlay
          fluid={false}
          width={"100%"}
          height={"100%"}
          poster={posterImage}
          src={vedioUrl}
        >
          <LoadingSpinner />
          <BigPlayButton className="text-secondary bg-white " position="center" />
          <ControlBar
            className="!bg-black  !justify-center !items-center "
            autoHide={false}
          >
            <ReplayControl seconds={10} order={2.2} />
            <ForwardControl seconds={10} order={3.2} />
          </ControlBar>
        </Player>
      )}

      {/* Pre-roll Ad Modal */}
      <AdVideoModal
        isOpen={isAdModalOpen}
        adData={adData}
        onComplete={handleAdDone}
        onClose={closeAdModal}
      />
    </div>
  );
};

export default VedioPlayer;

